var _learnq = _learnq || [];
var buttons = document.querySelectorAll('.card .add-to-cart');
buttons.forEach(button => {
    button.addEventListener('click', function (e) {

        // Send a request to shopify for the current cart contents
        var cartContents = fetch(window.Shopify.routes.root + 'cart.js')
            .then(response => response.json())
            .then(data => {
                // Build the array of products in the cart
                var itemList = [];
            
                data['items'].forEach(function (item, i) {
                    var itemObj = new Object();
                    itemObj.variant_id = item['variant_id'];
                    itemObj.sku = item['sku'];
                    itemObj.title = item['product_title'];
                    itemObj.quantity = item['quantity'];
                    itemObj.price = item['price'] / 100;
                    itemObj.compareAtPrice = item['compare_at_price'] / 100;
                    itemObj.RowTotal = item['line_price'] / 100;
                    itemObj.url = 'https://purple-brand.com' + item['url'];
                    itemObj.image = item['featured_image']['url'];
                    itemList.push(itemObj);                    
                });
                // Push the add to cart event to Klaviyo

                _learnq.push(['track', 'Added to Cart',
                    {
                        "Name": button.closest('.card').getAttribute('data-title'),
                        "ProductID": button.closest('.card').getAttribute('data-id'),
                        "Categories": button.closest('.card').getAttribute('data-collections').split('?'),
                        "ImageURL": button.closest('.card').getAttribute('data-image'),
                        "URL": button.closest('.card').getAttribute('data-url'),
                        "Brand": 'PURPLE BRAND',
                        "Price": button.closest('.card').getAttribute('data-price'),
                        "CompareAtPrice": button.closest('.card').getAttribute('data-compareAtPrice')                                                                                
                    }
                ]);
            });

        jQuery.ajax({
            type: 'GET',
            url: '/cart.json',
            data: {},
            dataType: 'json',
            success: function (response) {
                // Build the array of products in the cart
                var itemList = [];
                response['items'].forEach(function (item, i) {
                    var itemObj = new Object();
                    itemObj.variant_id = item['variant_id'];
                    itemObj.sku = item['sku'];
                    itemObj.title = item['product_title'];
                    itemObj.quantity = item['quantity'];
                    itemObj.price = item['price'] / 100;
                    itemObj.price = item['compare_at_price'] / 100;
                    itemObj.RowTotal = item['line_price'] / 100;
                    itemObj.url = 'https://purple-brand.com' + item['url'];
                    itemObj.image = item['featured_image']['url'];
                    
                });
                // Push the add to cart event to Klaviyo
                _learnq.push(['track', 'Added to Cart',
                    {
                        "Name": button.closest('.card').getAttribute('data-title'),
                        "ProductID": button.closest('.card').getAttribute('data-id'),
                        "Categories": button.closest('.card').getAttribute('data-collections').split('?'),
                        "ImageURL": button.closest('.card').getAttribute('data-image'),                         
                        "URL": button.closest('.card').getAttribute('data-url'),
                        "Price": button.closest('.card').getAttribute('data-price'),
                        "CompareAtPrice": button.closest('.card').getAttribute('data-compareAtPrice')                                                                                              
                    }
                ]);
            }
        });
    });
});